"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getListClassNames = list_type => {
  let ulStyle = '';
  let liStyle = '';
  switch (list_type) {
    case 'unstyled':
      ulStyle = 'list-unstyled';
      break;
    case 'inline':
      ulStyle = 'list-inline';
      liStyle = 'list-inline-item';
      break;
    case 'comma':
      ulStyle = 'comma-list';
      break;
    case 'separated':
      ulStyle = 'separated-list';
      break;
    default:
      break;
  }
  return {
    ulStyle,
    liStyle
  };
};
const ListBasicItem = _ref => {
  let {
    children,
    liStyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: liStyle
  }, children);
};
ListBasicItem.displayName = 'ListBasic.ListBasicItem';
ListBasicItem.propTypes = {
  /**
   * The contents of the List Item.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The style of the List Item.
   */
  liStyle: _propTypes.default.string
};
const ListBasic = _ref2 => {
  let {
    children,
    unordered,
    variant
  } = _ref2;
  let listStyles = {};
  if (unordered) {
    listStyles = getListClassNames(variant);
  }
  const listItemsWithVariants = _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {
    liStyle: listStyles.liStyle
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, unordered ? /*#__PURE__*/_react.default.createElement("ul", {
    className: listStyles.ulStyle
  }, listItemsWithVariants) : /*#__PURE__*/_react.default.createElement("ol", null, children));
};
ListBasic.ListBasicItem = ListBasicItem;
ListBasic.propTypes = {
  /**
   * The content of the list.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Set the list style
   */
  unordered: _propTypes.default.bool,
  /**
   * What type of unordered list is it? One of: "unstyled", "inline", "comma",
   * "separated". Only applies to unordered lists.
   */
  variant: _propTypes.default.oneOf(['', 'unstyled', 'inline', 'comma', 'separated'])
};
ListBasic.defaultProps = {
  unordered: true,
  variant: ''
};
var _default = exports.default = ListBasic;